import { getTripDocRef, getTripsCollectionRef } from "../paths";
import { BaseFirestoreRepository } from "./BaseFirestoreRepository";

export class FirestoreTripRepository extends BaseFirestoreRepository {
  async upsertEntity(entity, scope) {
    return this.upsert(
      getTripDocRef(this.db, entity.id),
      this.addStorageMarker({
        ...entity,
        organizationId: scope.organizationId,
        vesselId: scope.vesselId,
      })
    );
  }

  async deleteEntity(entityId) {
    return this.delete(getTripDocRef(this.db, entityId));
  }

  async listByVoyageId(voyageId) {
    return this.listByField(getTripsCollectionRef(this.db), "voyageId", voyageId);
  }

  async getEntity(tripId) {
    const entity = await this.get(getTripDocRef(this.db, tripId));
    return this.isManagedV2Document(entity) ? entity : null;
  }
}
